import { Box, Chip, Paper } from '@mui/material';
import Text from '../../../../components/detail/components/Text.component';
import {
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
} from '@mui/icons-material';
import dayjs from 'dayjs';

export const DetailConf = {
  initialState: {
    loading: false,
    error: null,
    data: null,
    meta: null,
  },
  fields: [
    {
      type: 'text',
      label: '',
      key: 'attributes.id_agent_NA.data.attributes.id_users_permissions_user.data.attributes',
      xs: 12,
      sm: 4,
      lg: 2,
    },
    {
      type: 'text',
      label: '',
      key: 'attributes.mexal_validation',
      xs: 12,
      sm: 4,
      lg: 3,
    },
    {
      type: 'text',
      label: '',
      key: 'attributes.registration_date',
      xs: 12,
      sm: 4,
      lg: 3,
    },
    {
      type: 'text',
      label: '',
      key: 'attributes.is_central_agent',
      xs: 12,
      sm: 4,
      lg: 3,
    },
    {
      type: 'text',
      label: '',
      key: 'attributes.note',
      xs: 12,
    },
    {
      type: 'text',
      label: 'Formalities',
      key: 'attributes.formalities',
      xs: 12,
      sm: 4,
      lg: 2,
      ml: 0.5,
    },
    {
      type: 'text',
      label: 'ISPS',
      key: 'attributes.isps',
      xs: 12,
      sm: 4,
      lg: 1.5,
    },
    {
      type: 'text',
      label: 'Garbage',
      key: 'attributes.garbage',
      xs: 12,
      sm: 4,
      lg: 2,
    },
    {
      type: 'text',
      label: 'Category',
      key: 'attributes.id_provenence_list.data.attributes.provenence_group.data.attributes.group',
      xs: 12,
      sm: 4,
      lg: 2,
    },
    {
      type: 'text',
      label: 'Sales Channel',
      key: 'attributes.id_provenence_list.data.attributes.provenence_sales_channel.data.attributes.sales_channel',
      xs: 12,
      sm: 4,
      lg: 2,
    },
    {
      type: 'text',
      label: 'First Contact',
      key: 'attributes.id_provenence_list.data.attributes.first_contact',
      xs: 12,
      sm: 4,
      lg: 2,
    },
    {
      type: 'text',
      label: '',
      key: 'attributes.id_provenence_list.data.attributes.note',
      xs: 12,
    },
  ],
  formatValue: (key, value) => {
    switch (key) {
      case 'attributes.id_agent_NA.data.attributes.id_users_permissions_user.data.attributes':
        return value?.name && value?.surname ? (
          <Text
            value={`${value?.name || ''} ${value?.surname || ''}`}
            sx={{ fontWeight: 'bold' }}
          />
        ) : (
          <Box pl={0.5}>
            <Text label='NA Agent' value={'-'} sx={{ fontWeight: 'bold' }} />
          </Box>
        );
      case 'attributes.mexal_validation':
        return (
          <Chip
            icon={value ? <CheckCircleIcon /> : <CancelIcon />}
            label='Mexal Validation'
            color={value ? 'success' : 'error'}
            variant='outlined'
          />
        );
      case 'attributes.registration_date':
        return (
          <Text
            label='Validation Date'
            value={value ? dayjs(value).format('DD-MM-YYYY') : '-'}
          />
        );
      case 'attributes.is_central_agent':
        return (
          <Chip
            icon={value ? <CheckCircleIcon /> : <CancelIcon />}
            label='Central Agent'
            color={value ? 'success' : 'error'}
            variant='outlined'
          />
        );
      case 'attributes.note':
        if (!value) return null;
        return (
          <Paper
            elevation={0}
            sx={{
              px: 1,
              my: 1,
              width: '100%',
              background:
                'linear-gradient(135deg,rgb(255, 217, 159) 0%,rgb(253, 237, 185) 100%)',
              borderRadius: 1,
              border: '1px solid rgba(0,0,0,0.05)',
            }}
          >
            <Text variant='subtitle2' label='Note' value={value} />
          </Paper>
        );
      case 'attributes.id_provenence_list.data.attributes.note':
        if (!value) return null;
        return (
          <Paper
            elevation={0}
            sx={{
              px: 1,
              my: 1,
              width: '100%',
              background:
                'linear-gradient(135deg,rgb(255, 217, 159) 0%,rgb(253, 237, 185) 100%)',
              borderRadius: 1,
              border: '1px solid rgba(0,0,0,0.05)',
            }}
          >
            <Text variant='subtitle2' label='Provenance Note' value={value} />
          </Paper>
        );

      case 'attributes.formalities':
        return <Text label='Formalities' value={value || '-'} />;

      case 'attributes.id_provenence_list.data.attributes.provenence_group.data.attributes.group':
        return <Text label='Category' value={value || '-'} />;

      case 'attributes.id_provenence_list.data.attributes.provenence_sales_channel.data.attributes.sales_channel':
        return <Text label='Sales channel' value={value || '-'} />;

      case 'attributes.id_provenence_list.data.attributes.first_contact':
        return <Text label='First contact' value={value || '-'} />;

      default:
        return null;
    }
  },
};
